import React from 'react';

import { ChevronLeft as LeftIcon, ChevronRight as RightIcon } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import CustomList from './CustomList';
import { intersection, not, union } from './helper';

const TransferList = (props) => {
  const { selected, setSelected, notSelected, setNotSelected, allFieldsSelected, primaryKeys } = props;

  const [checked, setChecked] = React.useState([]);

  const [left, setLeft] = [notSelected, setNotSelected];
  const [right, setRight] = [selected, setSelected];

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if(!left.some(x => primaryKeys.includes(x)))
      items = items.filter(x => !primaryKeys.includes(x))
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  return (
    <Box
      sx={{
        flex: '1 1 auto',
        justifyContent: 'space-between',
        overflowX: 'hidden',
        overflowY: 'hidden',
        height: '0px',
        display: 'flex',
        gap: 2,
        my: 1,
      }}
    >
      <CustomList
        title="Available"
        handleToggle={handleToggle}
        handleToggleAll={handleToggleAll}
        numberOfChecked={numberOfChecked}
        allFieldsSelected={allFieldsSelected}
        checked={checked}
        items={left}
        primaryKeys={primaryKeys}
        isRight={false}
      />
      <Box
        sx={{ display: 'flex', flexDirection: 'column', flex: 0, gap: 1, maxWidth: '24px' }}
        justifyContent="center"
        alignItems="center"
        px={2}
      >
        <Button
          variant="contained"
          size="small"
          color="primary"
          sx={{
            borderRadius: '4px',
            minWidth: '24px',
          }}
          onClick={handleCheckedRight}
          disabled={leftChecked.length === 0 || allFieldsSelected}
          aria-label="move selected right"
        >
          <RightIcon />
        </Button>
        <Button
          variant="contained"
          size="small"
          color="primary"
          sx={{
            borderRadius: '4px',
            minWidth: '24px',
          }}
          onClick={handleCheckedLeft}
          disabled={rightChecked.length === 0 || allFieldsSelected}
          aria-label="move selected left"
        >
          <LeftIcon />
        </Button>
      </Box>
      <CustomList
        title="Chosen"
        handleToggle={handleToggle}
        handleToggleAll={handleToggleAll}
        numberOfChecked={numberOfChecked}
        checked={checked}
        primaryKeys={primaryKeys}
        allFieldsSelected={allFieldsSelected}
        items={right}
        isRight
      />
    </Box>
  );
};

export default TransferList;
